export const environment = {
  production: true,
  env: 'Production',
  storageEncryptionKey: 'prod-key-change-in-production'
};
